<script lang="ts">
  import { BulletPoint } from '../../components/index';
  import { getHref } from '../../helpers/sections-helper';
  import './css/achievements.scss';
  import type { Achievements } from '../types';

  export let properties: Achievements;

  $: ({ button, callouts, headline, items } = properties);
</script>

<section class="achievements">
  <div class="wrapper">
    <h2 class="h2">{@html headline.value}</h2>
    <div class="achievements-holder">
      {#each items as item}
        <div class="achievement-box">
          <div class="achievement-top">
            <h3 class="h3">{@html item?.label?.value}</h3>
            <img
              src={item?.icon?.value}
              alt="icon-img"
              loading="lazy"
              width="40"
              height="40"
            />
          </div>
          <p class="text-small--bold">{@html item?.title?.value}</p>
        </div>
      {/each}
    </div>
    {#if button?.label?.length}
      <div class="bottom-boxes">
        <a
          id="achievements-book-now"
          target={button.link_type === 'External' ? '_blank' : ''}
          class="primary-button open-form-js"
          href={getHref(button.link_type, button.link)}>{@html button.label}</a
        >
        <div class="small-text-box">
          {#each callouts.value as item}
            <div>
              <BulletPoint bulletIcon={callouts?.icon} />
              <p class="text-small">{@html item}</p>
            </div>
          {/each}
        </div>
      </div>
    {/if}
  </div>
</section>
